export default {
  title: 'Dashboard',
  myAssets: 'My Assets',
  myAccount: 'My Account',
  unit: 'Unit: {currency}',
  totalAssets: 'Total Assets',
  fund: {
    fundStatistics: 'Fund Statistics',
    totalDeposit: 'Total Deposit',
    totalWithdraw: 'Total Withdrawal',
    netDeposit: 'Net Inflow',
    transferAmount: 'Transfer Amount',
  },
  time: {
    yesterday: 'Yesterday',
    lastWeek: 'Last Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    all: 'All',
  },
  analysis: {
    title: 'P/L Analysis',
    allVarieties: 'All Varieties',
    radio: {
      profitPerHour: 'Profit (Hourly)',
      profitPerDay: 'Profit (Daily)',
      netValueCurve: 'Net Value Curve',
    },
    selectPlaceholder: 'Please select',
    metrics: {
      balance: 'Balance',
      credit: 'Credit',
      totalProfit: 'Total Profit',
      profitRate: 'Profit Rate',
      positionOrders: 'Open Orders',
      orderUnitSuffix: 'orders',
      currentEquity: 'Current Equity',
      totalDeposit: 'Total Deposit',
      totalWithdraw: 'Total Withdrawal',
      totalLots: 'Total Lots',
      totalOrders: 'Total Orders',
    },
    hourSuffix: 'h',
  },
  invite: {
    title: 'Invite Customers',
    myCustomers: 'My Customers',
    selectGroupPlaceholder: 'Please select group',
    downloadQRCode: 'Download QR Code',
    inviteLink: 'Invite Link',
    inviteCode: 'Invitation Code',
    messages: {
      linkCopied: 'Invite link copied',
      copyFailed: 'Copy failed',
      codeCopied: 'Invitation code copied',
    },
  },
  shortCut: {
    quickActions: 'Quick Actions',
    depositFast: 'Fast Deposit',
    withdraw: 'Withdraw',
    transfer: 'Transfer',
  },
  accounts: {
    walletAccount: 'Wallet Account',
    dealAccount: 'Trading Account',
    intelligentOrderFollowing: 'Intelligent Order Following',
    pamm: 'PAMM',
  },
  notices: {
    kyc: {
      template:
        'You have completed your first deposit. Please complete KYC verification before {deadline} (remaining {leftTime} days) to ensure normal account usage.',
      btn: 'Complete Now',
    },
    ib: {
      template: 'You have an IB agreement to sign',
      btn: 'Sign Now',
    },
    phone: {
      template: 'To protect your account security, please complete phone binding verification now.',
      btn: 'Verify Now',
    },
  },
  dateFormatYMD: 'YYYY-MM-DD',
}
